import { OrderCompletionProgress } from "../types/OrderCompletionProgress";

const completionProgressMapping: Record<OrderCompletionProgress, string> = {
    [OrderCompletionProgress.None]: "0%",
    [OrderCompletionProgress.LessOrEqualHalf]: "1% - 50%",
    [OrderCompletionProgress.MoreThanHalf]: "51% - 99%",
    [OrderCompletionProgress.Completed]: "100%"
};

export const mapCompletionProgressToOption = (key: number): string => {
    return (
        completionProgressMapping[key as OrderCompletionProgress] ||
        completionProgressMapping[OrderCompletionProgress.None]
    );
};

export const getCompletionProgressOptions = (): Array<{ key: OrderCompletionProgress; text: string }> => {
    return Object.entries(completionProgressMapping).map(([key, text]) => ({
        key: Number(key),
        text
    }));
};
